module.exports = __webpack_public_path__ + "static/media/firefox.e525dfa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/firefox.png
// module id = 409
// module chunks = 1